import { EBonusStatus } from 'shared/types/bonusStatus';
import { TApplicationState } from 'shared/types/redux';

export const selectModalStatus = (state: TApplicationState): EBonusStatus => {
  return state.modal.status;
};
